import { log } from 'log';
import { usePushSubscription } from 'server';

import * as constants from '../constants';

export const useOnIpChange = ({
    sdk,
    nextTime,
    triggerGeolocation,
    setTransactionID,
    triggerTimestampRef,
    setLicense,
    setNextTime
}) => {
    usePushSubscription(31133, () => async (pushMessage) => {
        if (!sdk || !nextTime) {
            return;
        }

        const { action } = pushMessage.data;
        const actionType = Object.keys(action);

        if (actionType.includes('actionIpChangedInfo')) {
            log('gcInfo', { event: 'actionIpChangedInfo' });

            // unset current timeout
            triggerTimestampRef.current = null;
            setTransactionID(null);
            setLicense(null);
            setNextTime(0);

            await triggerGeolocation({
                reason: constants.GEOLOCATION_REASON.IP_CHANGE_CHECK
            });
        }
    }, [
        sdk,
        nextTime,
        triggerGeolocation,
        setNextTime,
        setLicense,
        setTransactionID,
        triggerTimestampRef
    ]);
};
